module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE STORY DEVOTIONAL")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct1p",
    attrs: {
      "id": "p0015-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#fn_8",
      "id": "sn_8"
    }
  }, [_vm._v("DAY 8")])]), _vm._v(" "), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#fn_8"
    }
  }, [_vm._v("COUNTERINTUITIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_c('span', [_c('i', [_vm._v("The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" God commanded the man, “You are free to eat from any tree in the garden; but you must not eat from the tree of the knowledge of good and evil, for when you eat from it you will certainly die.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("GENESIS")]), _vm._v(" 2:16–17")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0015-04-4"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("T")]), _vm._v("he study was simple. Case #1: Let the elementary school students play on a playground without a fence: they were free to go wherever they wanted—the basketball courts, hopscotch grids, four-squares, tetherballs, jungle gyms. Case #2: Let the elementary school students play on that same playground, but now with a fence around the perimeter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the first case, the researchers were surprised to see the students cluster in the middle of the play area. In the second case—when a fence set the boundaries—the students took full advantage of the entire area and all the fun it offered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Boundaries mean freedom, and the one boundary in Eden was simple: “You must not eat from the tree of the knowledge of good and evil.” God established this boundary—and this is true for every law he established—for the good of the people he loves. Life goes well when we live within the fence God has provided us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx3"
  }, [_vm._v("GOD’S BOUNDARIES MEAN YOUR FREEDOM!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7413faa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter11.vue
// module id = 93
// module chunks = 0